import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import { I18nProvider, useI18n } from './i18n/I18nContext';
import router from './router';
import './App.css';

function AppWithAntdLocale() {
  const { locale } = useI18n();
  return (
    <ConfigProvider locale={locale === 'zh' ? zhCN : enUS}>
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

function App() {
  return (
    <I18nProvider>
      <AppWithAntdLocale />
    </I18nProvider>
  );
}

export default App;
